import type { Dossier, DossierSection } from '@/mocks/dossiers';

interface Props {
  dossier: Dossier;
}

const SectionBlock = ({ section, index }: { section: DossierSection; index: number }) => (
  <section id={`section-${index}`} className="scroll-mt-24">
    <h2 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
      <span className="mr-3 text-primary-500">{String(index + 1).padStart(2, '0')}</span>
      {section.heading}
    </h2>
    <div className="mt-4 space-y-4">
      {section.paragraphs.map((paragraph) => (
        <p key={paragraph.slice(0, 16)} className="font-body text-sm leading-[1.9] text-foreground-700 md:text-base">
          {paragraph}
        </p>
      ))}
    </div>
    {section.quote && (
      <blockquote className="mt-6 border-l-2 border-accent-500 bg-accent-50 px-5 py-4 font-heading text-sm leading-relaxed text-accent-900 md:text-base">
        {section.quote}
      </blockquote>
    )}
  </section>
);

export default function ArticleBody({ dossier }: Props) {
  return (
    <div className="space-y-12">
      <section id="question" className="scroll-mt-24">
        <div className="rounded-lg border border-primary-200 bg-primary-50 p-6 md:p-7">
          <span className="inline-flex items-center gap-1.5 font-label text-xs tracking-[0.24em] text-primary-700">
            <i className="ri-question-line" />
            核心疑问
          </span>
          <p className="mt-3 font-heading text-lg font-semibold leading-relaxed text-foreground-950 md:text-xl">
            {dossier.question}
          </p>
        </div>
      </section>

      {dossier.sections.map((section, index) => (
        <SectionBlock key={section.heading} section={section} index={index} />
      ))}

      <section id="takeaways" className="scroll-mt-24">
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">结论要点</h2>
        <p className="mt-3 font-body text-sm text-foreground-600">下面四条是可以直接带走的判断方式，与前面的素材一一对应。</p>
        <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {dossier.takeaways.map((item, index) => (
            <li
              key={item}
              className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4"
            >
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-secondary-500 font-label text-xs text-background-50">
                {index + 1}
              </span>
              <span className="font-body text-sm leading-relaxed text-foreground-700">{item}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}